/**
 * Access token y datos de sesión en sessionStorage (se borran al cerrar pestaña).
 * El refresh token vive en la cookie HttpOnly rentahab_RT (gestionada por el backend).
 */

const KEYS = {
  TOKEN: 'rentahab_access_token',
  USER: 'rentahab_user',
  EXPIRES_AT: 'rentahab_token_expires_at',
  LAST_ACTIVITY: 'rentahab_last_activity',
};

export const tokenStorage = {
  getAccessToken: () => sessionStorage.getItem(KEYS.TOKEN),

  getUser: () => {
    try {
      const raw = sessionStorage.getItem(KEYS.USER);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },

  getTokenExpiresAt: () => parseInt(sessionStorage.getItem(KEYS.EXPIRES_AT) || '0', 10),

  getLastActivity: () => parseInt(sessionStorage.getItem(KEYS.LAST_ACTIVITY) || '0', 10),

  setSession: ({ token, user, expiresIn = null }) => {
    if (token) {
      sessionStorage.setItem(KEYS.TOKEN, token);
    }
    if (user) {
      sessionStorage.setItem(KEYS.USER, JSON.stringify(user));
    }
    sessionStorage.setItem(KEYS.LAST_ACTIVITY, Date.now().toString());
    if (expiresIn) {
      sessionStorage.setItem(KEYS.EXPIRES_AT, String(Date.now() + expiresIn * 1000));
    }
  },

  setAccessToken: (token, expiresIn = null) => {
    sessionStorage.setItem(KEYS.TOKEN, token);
    if (expiresIn) {
      sessionStorage.setItem(KEYS.EXPIRES_AT, String(Date.now() + expiresIn * 1000));
    }
  },

  touchActivity: () => {
    sessionStorage.setItem(KEYS.LAST_ACTIVITY, Date.now().toString());
  },

  isAuthenticated: () => !!sessionStorage.getItem(KEYS.TOKEN),

  clear: () => {
    Object.values(KEYS).forEach((key) => sessionStorage.removeItem(key));
  },
};

export default tokenStorage;
